import PropTypes from 'prop-types';
import React from 'react';

class HoverButton extends React.PureComponent {
  static displayName = 'HoverButton';

  static propTypes = {
    disabled: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    hoverIcon: PropTypes.string,
    disabledIcon: PropTypes.string,
    children: PropTypes.any,
  };

  static defaultProps = {
    className: '',
    style: {},
    disabled: false,
  };

  state = {
    hovered: false,
  };

  setHover = () => {
    this.setState({
      hovered: true,
    });
  };

  removeHover = () => {
    this.setState({
      hovered: false,
    });
  };

  render() {
    let icon = this.props.icon;

    if (this.props.disabled && this.props.disabledIcon) {
      icon = this.props.disabledIcon;
    } else if (this.state.hovered && this.props.hoverIcon) {
      icon = this.props.hoverIcon;
    }

    return <button className={this.props.className + ' btn icon-button'} disabled={this.props.disabled}
        onClick={this.props.onClick} onMouseOver={this.setHover} onMouseOut={this.removeHover}>
      <i className={'bl ' + icon} />{this.props.children}
    </button>;
  }
}

export default HoverButton;
